<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-text-field
        v-model="NameEN"
        v-bind:label="$t('info_card.name_en')"
        v-bind:rules="nameEnRules"
        @input="
          (v) => {
            NameEN = v.toUpperCase();
          }
        "
        onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123 ) || (event.charCode == 45) || (event.charCode == 39) || (event.charCode == 46) || (event.charCode == 32)"
        onPaste="return false"
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        v-model="SurnameEN"
        v-bind:label="$t('info_card.surname_en')"
        v-bind:rules="surenameEnRules"
        @input="
          (v) => {
            SurnameEN = v.toUpperCase();
          }
        "
        onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123 ) || (event.charCode == 45) || (event.charCode == 39) || (event.charCode == 46) || (event.charCode == 32)"
        onPaste="return false"
        outlined
        dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { objectTranslator } from "../../helper/translator";
import validator from "../../helper/validator";
export default {
  name: "nameEnCard",
  props: ["value_nameEn", "value_surnameEn"],
  data() {
    return {
      nameEnRules: [validator.required],
      surenameEnRules: [validator.required],
    };
  },
  methods: {
    objectTranslator,
    forceUppercase(e, o, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(o, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },
  },
  computed: {
    NameEN: {
      get() {
        return this.value_nameEn;
      },
      set(value) {
        this.$emit("input_nameEn", value);
      },
    },
    SurnameEN: {
      get() {
        return this.value_surnameEn;
      },
      set(value) {
        this.$emit("input_surnameEn", value);
      },
    },
  },
};
</script>
